import { useEffect, useRef, useState } from "react"
import { useGlobalSettings } from "@/entities/globalSettings/useGlobalSettings"
import { QueryRender } from "@/components/helpers/QueryRender"

interface Props {
   searchText: string
   setSearchText: (text: string) => void
   selectedGroups: string[]
   setSelectedGroups: React.Dispatch<React.SetStateAction<string[]>>
}

export function YoungsFilterSearchBar({
   searchText,
   setSearchText,
   selectedGroups,
   setSelectedGroups,
}: Props) {
   const [searchOpen, setSearchOpen] = useState(false)
   const searchInputRef = useRef<HTMLInputElement>(null)
   const globalSettingsQuery = useGlobalSettings()

   useEffect(() => {
      if (globalSettingsQuery.data) {
         setSelectedGroups(globalSettingsQuery.data.groups)
      }
   }, [globalSettingsQuery.data?.groups])

   const handleSearchOpen = () => {
      setSearchOpen(true)
      setTimeout(() => searchInputRef.current?.focus(), 100)
   }

   return (
      <div className="filter-bar">
         <div className="relative py-2 w-full">
            <div
               className={`z-10 bg-white  absolute inset-0 flex items-center bg-base-100 transition-all duration-300 ${
                  searchOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"
               }`}
            >
               <input
                  ref={searchInputRef}
                  type="text"
                  placeholder="Rechercher un jeune..."
                  className="input input-bordered w-full"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onBlur={() => !searchText && setSearchOpen(false)}
                  onKeyDown={(e) => e.key === "Escape" && setSearchOpen(false)}
               />
               <button
                  className="btn btn-sm ml-2"
                  onClick={() => {
                     setSearchText("")
                     setSearchOpen(false)
                  }}
               >
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth={1.5}
                     stroke="currentColor"
                     className="w-6 h-6"
                  >
                     <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
               </button>
            </div>
            <div
               className={`flex items-center transition-all duration-300 ${
                  searchOpen ? "opacity-0 scale-95" : "opacity-100 scale-100"
               }`}
            >
               <div className="flex flex-wrap gap-2 flex-1 items-center">
                  <QueryRender query={globalSettingsQuery} minHeight="0">
                     {(settings) =>
                        settings.groups.map((group) => (
                           <button
                              key={group}
                              className={`btn btn-neutral btn-sm ${
                                 selectedGroups.includes(group) ? "" : "btn-outline"
                              }`}
                              onClick={() => {
                                 setSelectedGroups((prev: string[]): string[] =>
                                    prev.includes(group)
                                       ? prev.filter((g) => g !== group)
                                       : [...prev, group],
                                 )
                              }}
                           >
                              {group}
                           </button>
                        ))
                     }
                  </QueryRender>
               </div>
               <button className="btn btn-neutral btn-sm ml-4  " onClick={handleSearchOpen}>
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth={1.5}
                     stroke="currentColor"
                     className="w-6 h-6"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                     />
                  </svg>
               </button>
            </div>
         </div>
      </div>
   )
}
